/**
 * Rating (starts) component
 *
 * ## Ussage
 *
 * <rating [value]="4"></rating>
 *
 * ## Output sample
 * <rating [value]="3.5">
 *   <i class="rate-full"></i>
 *   <i class="rate-full"></i>
 *   <i class="rate-full"></i>
 *   <i class="rate-half"></i>
 *   <i class="rate-empty"></i>
 * </rating>
 *
 */

import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RatingComponentDef } from '@df/ui/common/rating.component.def';

@Component({
    selector: 'rating',
    template: `
        @for (item of items; track $index) {
            <i
                [ngClass]="{
                    'rate-empty': item >= maxHalf,
                    'rate-half': item < maxHalf && item >= maxFull,
                    'rate-full': item < maxFull
                }"
            ></i>
        }
    `,
    standalone: true,
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingComponent extends RatingComponentDef {
    protected override asyncCd = false;
}
